import React from 'react'

import { IconProps, iconColor } from './IconProps'

export const DepositAlertIcon: React.FC<IconProps> = (props) => {
  const { size = 44 } = props

  return (
    <div style={{ width: size, height: size }}>
      <svg
        width='100%'
        height='100%'
        viewBox='0 0 44 44'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <rect width='44' height='44' rx='22' fill={iconColor({ ...props, color: 'badgeYellow' })} />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M22 11.3334C16.1089 11.3334 11.3333 16.109 11.3333 22.0001C11.3333 27.8911 16.1089 32.6667 22 32.6667C27.891 32.6667 32.6666 27.8911 32.6666 22.0001C32.6666 16.109 27.891 11.3334 22 11.3334ZM8.66663 22.0001C8.66663 14.6363 14.6362 8.66675 22 8.66675C29.3638 8.66675 35.3333 14.6363 35.3333 22.0001C35.3333 29.3639 29.3638 35.3334 22 35.3334C14.6362 35.3334 8.66663 29.3639 8.66663 22.0001ZM22 15.9337C22.7363 15.9337 23.3333 16.5306 23.3333 17.267V22.6003C23.3333 23.3367 22.7363 23.9337 22 23.9337C21.2636 23.9337 20.6666 23.3367 20.6666 22.6003V17.267C20.6666 16.5306 21.2636 15.9337 22 15.9337ZM20.6002 26.6003C20.6002 25.864 21.1972 25.267 21.9336 25.267H22.0664C22.8027 25.267 23.3997 25.864 23.3997 26.6003V26.7337C23.3997 27.0882 23.2585 27.4281 23.0073 27.6783C22.7561 27.9285 22.4157 28.0684 22.0611 28.067L21.9283 28.0665C21.194 28.0636 20.6002 27.4675 20.6002 26.7332V26.6003Z'
          fill='white'
        />
      </svg>
    </div>
  )
}
